/**
 * Gera IDs únicos para mensagens e conversas
 * Usa timestamp + contador para evitar colisões em operações rápidas
 */

let counter = 0;
let lastTimestamp = 0;

/**
 * Gera um ID único baseado em timestamp + contador
 * Formato: timestamp_counter
 */
export const generateUniqueId = (prefix: string = ""): string => {
  const timestamp = Date.now();
  
  // Se é o mesmo timestamp, incrementa contador
  if (timestamp === lastTimestamp) {
    counter++;
  } else {
    counter = 0;
    lastTimestamp = timestamp;
  }
  
  const id = `${timestamp}_${counter}`;
  return prefix ? `${prefix}_${id}` : id;
};

/**
 * Gera ID para mensagem
 */
export const generateMessageId = (): string => {
  return generateUniqueId("msg");
};

/**
 * Gera ID para conversa
 */
export const generateConversationId = (): string => {
  return generateUniqueId("conv");
};
